import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Stack,Grid } from "@mui/material"
import Header from './Header';
import Loading from './Loading';
import VideoCard from './VideoCard';
import { useParams } from 'react-router';
import axios from 'axios';
import { config } from '../App';
import './VideoPage.css';
import { formatTime } from './VideoCard';
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown"
import Filter from './Filter';
const VideoPage = ()=>{
    const [loading,setLoading] = useState(false);
    const [currentVideo,setCurrentVideo] = useState();
    const [upVote,setUpVote] = useState();
    const [upVoteSelected,setUpVoteSelected] = useState(false);
    const [downVote,setDownVote] = useState();
    const [downVoteSelected,setDownVoteSelected] = useState(false);
    const [videos,setVideos] = useState();
  

    const {id} = useParams();




     const incrementViewCount = async ()=>{
        let res = await axios.patch(`${config.endpoint}/v1/videos/${id}/views`)
        return res;
    }

    // const getVideos = async ()=>{
    //     try {
    //         setLoading(true);
    //         let res = await axios.get(`${config.endpoint}/v1/videos`);
    //         setVideos(res.data.videos);
    //         setLoading(false);
    //     } catch (error) {
    //         setLoading(false);
    //     }
        
        
    // }


    useEffect(async ()=>{
        
        fetchVideoById();
        // getVideos();
        incrementViewCount();
        window.scrollTo(0, 0)
        
    },[id])

    const fetchVideoById = async ()=>{
        
        try {
            setLoading(true);
            let res = await axios.get(`${config.endpoint}/v1/videos/${id}`);
            // console.log(res.data)
            setCurrentVideo(res.data);
            setUpVote(res.data.votes.upVotes);
            setDownVote(res.data.votes.downVotes);
            setLoading(false);
            // console.log(res.data.videoLink);
        } catch (error) {
            setCurrentVideo(undefined);
            console.log(error)
            setLoading(false);
        }
    }

   

    const patchVoteRequest = async (voteType)=>{
        try {
            const res = await axios.patch(`${config.endpoint}/v1/videos/${id}/votes`,{vote:voteType,change:'increase'}, {
                headers:{
                    'Content-Type':'application/json'
                }
            });
            if(res.status >= 200 && res.status <= 300){
                return true;
            }
        } catch (error) {
            return false;
        }
    }

    const handleUpVote=()=>{
        setUpVoteSelected(true);
        if(patchVoteRequest('upVote')){
            setUpVote(upVote+1)
        }
        
        
    }

    const handleDownVote = ()=>{
        setDownVoteSelected(true);
        if(patchVoteRequest('downVote')){
            setDownVote(downVote+1)
        }
    }

    

    return(
        <>
            <Header isVideoPage={true}/>
            {loading ? <Loading/> : (<>
               
                <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center", width: "100%", height: "100vh" }}>
                    <Box className="iframe-parent">
                            <iframe
                                className="iframe"
                                src={`https://www.${currentVideo?.videoLink}`}
                                title={currentVideo?.title}
                            />

                    </Box>
                    <Box sx={{ width: "80vw", marginTop: "16px" }}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Box>
                                <h5 className='video-page-title'>{currentVideo?.title}</h5>
                                <div style={{display:'inline-flex',alignItems:'center'}}>
                                    <span className='video-page-subtitle'>{'+'+ currentVideo?.contentRating.split('+')[0]}</span>
                                    <div style={{backgroundColor:'#C2C2C2',width:'6px',height:'6px',borderRadius:'50%',marginLeft:'10px'}}></div>
                                    <span className='video-page-subtitle' style={{marginLeft:'10px'}}>{formatTime(currentVideo?.releaseDate)}</span>
                                </div>
                                
                            </Box>

                            <Box>
                                <Button variant='contained' className='votes-button' onClick={handleUpVote} sx={{background:upVoteSelected ? '4CA3FC':'#302e30'}} startIcon={<ThumbUpIcon sx={{color: upVoteSelected ? '#FFFFFF':'#797979'}}/>}>{upVote}</Button>
                                <Button variant='contained' className='votes-button' onClick={handleDownVote} sx={{marginLeft:'10px',background:downVoteSelected ? '4CA3FC':'#302e30'}}startIcon={<ThumbDownIcon sx={{color: downVoteSelected ? '#FFFFFF':'#797979'}}/>}>{downVote}</Button>
                            </Box>
                        </Stack>
                    </Box>
                    
                </Box>
                <Filter videoPage={true}/>
                </>
            )}
        </>
    )
}

export default VideoPage;